import React from 'react'
import "./Letreiro.css";

function Letreiro() {
  return (
    <div className='Letreiro-container'>
      <section className="social-mediaL">
        <div className="social-media-wrapL">
          <div className="footer-logoL">
            <div className="social-logoL">Tire suas dúvidas - Fale conosco</div>
            <div className="social-secondL">Contato</div>
          </div>
        </div>
      </section>
      </div>
  )
}

export default Letreiro